<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><a class="page" id="pii"></a><a class="page" id="piii"></a>Visualizing Disease</h1>
<h1 class="bk1">The Art and History of Pathological Illustrations</h1>
<p class="bkau"><span class="sm">DOMENICO</span> <span class="sm">BERTOLONI</span> <span class="sm">MELI</span></p>
<p class="bkpub">The University of Chicago Press</p>
<p class="bkpub1">Chicago and London</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-Bertoloni-Meli-0003.vue?fc37b9ac